module.exports = __webpack_public_path__ + "static/media/alimentacion_nota_blog.eab7608d.png";